import { createElement, useRef, useState } from 'react';
import searchIcon from '../../assets/icon/search/search.png';
import deleteIcon from '../../assets/icon/search/delete.png';
import { convertChildren } from '../../../src/utils/children-node-handle';
const SearchBar = (props) => {
    const { onSearch, searchText = true, autofocus = false, placeholder = '请输入', onConfirm, children, iconSrc, ...otherProps } = props;
    const [searchValue, setSearchValue] = useState();
    const searchInput = useRef(null);
    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };
    const confirm = () => {
        if (onConfirm) {
            onConfirm(searchValue);
        }
        searchInput?.current?.blur();
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            confirm();
        }
    };
    const clearValue = () => {
        setSearchValue('');
    };
    return (createElement("form", { action: "", className: "search-bar-form", ...otherProps, onSubmit: confirm },
        createElement("div", { className: "search-bar", onClick: onSearch },
            createElement("span", { className: "search-bar-icon" },
                createElement("img", { src: searchIcon, className: "search-bar-icon-img" })),
            createElement("input", { className: "search-bar-input", placeholder: placeholder, value: searchValue, autoFocus: autofocus, onChange: handleChange, onKeyDown: handleKeyDown, ref: searchInput }),
            searchValue ? (createElement("img", { className: "search-bar-delete-img", src: deleteIcon, onClick: clearValue })) : (''),
            searchText ? (createElement("span", { className: "search-bar-enter", onClick: confirm }, "\u641C\u7D22")) : (''),
            iconSrc &&
                convertChildren(children, 'img-right', {
                    imgSrc: iconSrc,
                    className: 'search-bar-right-icon',
                }))));
};
export default SearchBar;
